import React from 'react'

import Select from '../../../packages/kiti/components/form/Select'

const OPTIONS = [
  {
    id: 'instance',
    name: 'Ocorrência'
  },
  { id: 'conclusion', name: 'Conclusão' }
]

const NonComplianceEventTypesSelect = ({ ...props }) => {
  return <Select options={OPTIONS} {...props} />
}

export default NonComplianceEventTypesSelect
